<div class="seller-login-page">
  <nav class="seller-login-shortcuts" aria-label="Seller login shortcuts">
    <a [href]="storefrontHomeUrl" class="seller-shortcut-link">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
      <span>Home</span>
    </a>
    <a routerLink="/sellar-signup" class="seller-shortcut-link">Seller sign up</a>
    <a [href]="storefrontLoginUrl" class="seller-shortcut-link seller-shortcut-link--customer">Customer login</a>
    <a routerLink="/delivery/login" class="seller-shortcut-link">Delivery portal</a>
  </nav>

  <main class="seller-login-main" id="main-content">
    <div class="portal-banner portal-banner--seller" role="status">
      <span class="portal-banner__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <path d="M9 22V12h6v10"/>
        </svg>
      </span>
      <span class="portal-banner__label">Seller account</span>
      <span class="portal-banner__hint">Store · Orders · Products</span>
    </div>

    <div class="login-wrapper">
    <div class="login-card">
      <div class="card-left">
        <div class="login-content">
          <div class="login-header">
            <p class="portal-eyebrow">Seller account</p>
            <h1 class="login-title">Seller login</h1>
            <p class="login-tagline">Sign in to manage your store, products, and seller orders — not for shopping.</p>
          </div>

          <div *ngIf="errorMessage && !show2FA" class="error-message">
            {{ errorMessage }}
          </div>

          <div *ngIf="!show2FA">
            <form
              [formGroup]="loginForm"
              (submit)="$event.preventDefault()"
              (ngSubmit)="onLoginFormSubmit()"
              method="post"
              action="#"
              novalidate
              class="form"
            >
              <div class="form-group" *ngIf="!showPasswordModal">
                <label class="seller-login-field-label" for="seller-login-email">Email</label>
                <input
                  type="email"
                  formControlName="email"
                  placeholder="Your email address"
                  id="seller-login-email"
                  autocomplete="email"
                  (keydown.enter)="$event.preventDefault(); onContinueWithEmail()"
                />
              </div>
              <button
                *ngIf="!showPasswordModal"
                type="button"
                class="btn primary"
                [class.loading]="loading"
                [disabled]="loading"
                (click)="onContinueWithEmail()"
              >
                Continue
              </button>

              <!-- Password step: popup (same form — no nested <form>) -->
              <div
                *ngIf="showPasswordModal"
                class="seller-password-modal-backdrop"
                (click)="closePasswordModal()"
                role="presentation"
              ></div>
              <div
                *ngIf="showPasswordModal"
                class="seller-password-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="seller-password-modal-title"
                (click)="$event.stopPropagation()"
              >
                <button
                  type="button"
                  class="seller-password-modal__close"
                  (click)="closePasswordModal()"
                  [disabled]="loading"
                  aria-label="Close"
                >
                  ×
                </button>
                <h2 id="seller-password-modal-title" class="seller-password-modal__title">Enter your password</h2>
                <p class="seller-password-modal__email">{{ loginForm.get('email')?.value }}</p>
                <div class="form-group">
                  <label class="seller-login-field-label" for="seller-login-password">Password</label>
                <input
                  type="password"
                  formControlName="password"
                  placeholder="Your password"
                  id="seller-login-password"
                  autocomplete="current-password"
                  (keydown.enter)="$event.preventDefault(); onSubmit()"
                />
                </div>
                <div class="form-options">
                  <a routerLink="/seller-update-password" class="forgot-link">Forgot password?</a>
                </div>
                <button
                  type="button"
                  class="btn primary seller-password-modal__login"
                  [class.loading]="loading"
                  [disabled]="loading"
                  (click)="onSubmit()"
                >
                  {{ loading ? 'Logging in...' : 'Log in' }}
                </button>
              </div>
            </form>
          </div>

          <p class="signup">Don’t have an account? <a routerLink="/sellar-signup">Seller sign up</a></p>
          <div class="seller-login-extra">
            <a routerLink="/sellar-member-login" class="btn secondary">Login as Child Account</a>
          </div>

          <aside class="portal-switch portal-switch--inline">
            <p class="portal-switch__text">Looking to shop instead?</p>
            <a [href]="storefrontLoginUrl" class="portal-switch__link">Go to Customer login →</a>
          </aside>
        </div>
      </div>

      <div class="card-right card-right--seller">
        <div class="login-side-content">
          <div class="login-side-visual" aria-hidden="true">
            <div class="login-orbit login-orbit-1"></div>
            <div class="login-orbit login-orbit-2"></div>
            <div class="login-orbit login-orbit-3"></div>
            <div class="login-side-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <path d="M9 22V12h6v10"/>
              </svg>
            </div>
          </div>
          <h2 class="login-side-title">Seller portal</h2>
          <p class="login-side-desc">Manage your store dashboard, list products, fulfill orders, and track seller payouts.</p>
          <ul class="seller-benefits">
            <li>Manage products &amp; inventory</li>
            <li>Process seller orders</li>
            <li>View analytics &amp; payouts</li>
          </ul>
          <aside class="portal-switch portal-switch--panel">
            <p class="portal-switch__text">Looking to shop instead?</p>
            <a [href]="storefrontLoginUrl" class="portal-switch__link">Go to Customer login →</a>
          </aside>
        </div>
      </div>
    </div>
    </div>

    <div class="seller-login-trust">
      <span class="seller-trust-badge">Secure login</span>
      <span class="seller-trust-badge">Encrypted</span>
    </div>

    @if (show2FA) {
      <app-login-two-factor-step
        portal="seller"
        [maskedEmail]="getMaskedEmail()"
        [requiresAuthenticator]="requiresAuthenticator2FA"
        [loading]="loading"
        [errorMessage]="errorMessage"
        [showResend]="!requiresAuthenticator2FA"
        (verifyCode)="onVerify2FA($event)"
        (resend)="resend2FAOTP()"
        (back)="backToLogin()"
      />
    }
  </main>
</div>
